
import { Vue, Component } from 'vue-property-decorator';
// import SearchBar from '@/components/next/SearchBar.vue';
import { getUser, ifSave, getBaseInfo } from '../api';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
import { List, Dialog, Toast } from 'vant';
Vue.use(List)
  .use(Dialog)
  .use(Toast);
@Component({
  components: {
    // SearchBar,
  },
})
export default class User extends Vue {
  // search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  unionid: string | null = '';
  baseInfo: any = {};

  getStatusClass(enable: string) {
    if (enable === '-1') return 'status-fail';
    if (enable === '0') return 'status-pending';
    return 'status-success';
  }

  getCover(cover: any): string {
    if (!cover) return '';
    if (Array.isArray(cover)) return cover[0] || '';
    return String(cover).split('|')[0] || '';
  }

  async mounted() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
  }

  activated() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    // 每次进入页面重新加载数据
    this.finished = false;
    this.loading = false;
    this.onLoad();
  }
  AppLogin() {
    if (!window.token) {
      window.openApp('mUserLogin');
      return;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  onLoad() {
    const unionid = window.localStorage.getItem('unionid');
    const data = {
      unionid,
      token: window.token,
      appkey: window.appkey,
      wdid: window.udid,
    };
    getUser(data).then((res: any) => {
      this.list = res.data;
      this.finished = true;
      this.loading = false;
    });
  }
  goDetail(id: any, enable: string) {
    if (enable === '1') {
      this.$router.push(`homeDetail?id=${id}`);
    }
  }
}
